import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import {
  LanguageMenu,
  LanguageSwitcher,
} from '@/components/language-switcher';
import { ThemeToggle } from '@/components/theme-toggle';
import { Button } from '@/components/ui/button';

/** Minimal signed-out page for routes the redesign has not covered yet. */
export function PublicNotice({
  titleKey,
  bodyKey,
}: {
  titleKey: string;
  bodyKey: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center gap-4 px-6 text-center">
      {/* Every signed-out screen carries the switcher — the choice must not
          depend on which one you happen to land on. */}
      <div className="absolute top-4 right-4 flex items-center gap-1 sm:top-6 sm:right-6 sm:gap-2">
        <LanguageSwitcher className="hidden sm:inline-flex" />
        <LanguageMenu className="sm:hidden" />
        <ThemeToggle />
      </div>
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">{t(titleKey)}</h1>
        <p className="text-muted-foreground max-w-sm text-sm">{t(bodyKey)}</p>
      </div>
      <Button variant="outline" asChild>
        <Link to="/login">
          <ArrowLeft />
          {t('auth.register.backToSignIn')}
        </Link>
      </Button>
    </div>
  );
}
